export const PAGINATION_PAGE_SIZE = {
  SMALL: 10,
  MODERATE: 50,
  MEDIUM: 300,
  LARGE: 1000,
  EXTRA_LARGE: 10000,
  MAXIMUM_LARGE: 100000,
};

export const PAGINATION = {
  PAGE: 1,
  PAGE_SIZE: PAGINATION_PAGE_SIZE.SMALL,
};
